








import { Component, Vue } from "vue-property-decorator";
import PortfolioItem from "./PortfolioItem.vue";
import { Getter, State } from "vuex-class";

@Component({
  components: {
    PortfolioItem
  }
})
class MixinPortfolio extends Vue {
  @Getter("auth/isLogged") isLogged;

  @Getter("basis/account/isMixinBinded") isMixinBinded;

  @Getter("wallet/mixin/getTotalUsd") mixinTotalUsd;

  @State(state => state.app.mixinLoginOutDate) mixinLoginOutDate;

  @State(state => state.wallet.mixin.hidden) hidden;

  get meta() {
    const transfer = this.$common.utils.currency.transfer;
    const fiat = this.$common.utils.currency.fiat;
    const hideText = "*****";
    const isDark = this.$vuetify.theme.dark;

    const connectedMixin =
      this.isLogged && this.isMixinBinded && !this.mixinLoginOutDate;
    const mixinTotalBtc = transfer(this, {
      from: "USD",
      to: "BTC",
      value: this.mixinTotalUsd,
      precision: 8
    });
    const mixinTotalFiat = fiat(this, {
      value: this.mixinTotalUsd,
      from: "USD"
    });
    const mixinTotalBtcText = this.hidden ? hideText : `≈${mixinTotalBtc} BTC`;
    const mixinTotalLegalText = this.hidden ? hideText : `≈${mixinTotalFiat}`;

    return {
      item: {
        title: this.$t("wallet.mixin"),
        background: require("@/assets/images/background_1.png"),
        icon: require("@/assets/images/logo_mixin.png"),
        iconSize: 25,
        color: isDark ? "#1e2d33" : "#EBF9FF",
        content: !connectedMixin
          ? this.$t("wallet.mixin.connect")
          : mixinTotalLegalText,
        footer: !connectedMixin
          ? this.$t("wallet.mixin.connect.hint")
          : mixinTotalBtcText
      }
    };
  }
}
export default MixinPortfolio;
